import React from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const processed = React.useRef(false);

    React.useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sid = params.get("session_id");
        (async () => {
            if (sid) {
                try {
                    await api.post("/auth/session", { session_id: sid });
                } catch (e) {
                    console.error("Google auth failed", e);
                }
            }
            // Clean hash
            window.history.replaceState(null, "", window.location.pathname);
            await checkAuth();
            navigate("/cont", { replace: true });
        })();
    }, [navigate, checkAuth]);

    return (
        <div className="min-h-screen flex items-center justify-center font-mono text-muted-foreground">
            Autentificare în curs...
        </div>
    );
}
